import { render, staticRenderFns } from "./heros_dragable.vue?vue&type=template&id=18ed7c69&scoped=true&"
import script from "./heros_dragable.vue?vue&type=script&lang=js&"
export * from "./heros_dragable.vue?vue&type=script&lang=js&"
import style0 from "./heros_dragable.vue?vue&type=style&index=0&id=18ed7c69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ed7c69",
  null
  
)

export default component.exports